import { render, staticRenderFns } from "./CreateNewId.vue?vue&type=template&id=d62693a8&"
import script from "./CreateNewId.vue?vue&type=script&lang=js&"
export * from "./CreateNewId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports